import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-folder-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M18.3327 9.1665V14.1665C18.3327 17.4998 17.4993 18.3332 14.166 18.3332H5.83268C2.49935 18.3332 1.66602 17.4998 1.66602 14.1665V5.83317C1.66602 2.49984 2.49935 1.6665 5.83268 1.6665H7.08268C8.33268 1.6665 8.60768 2.03317 9.08268 2.6665L10.3327 4.33317C10.6493 4.74984 10.8327 4.99984 11.666 4.99984H14.166C17.4993 4.99984 18.3327 5.83317 18.3327 9.1665Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10" />
    </svg>
  `,
})
export class FolderIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 20 20');
}
